// extracted by mini-css-extract-plugin
export default {"containerNoStyle":"src-components-Antd-Drawer-css-module__containerNoStyle--L6yyb"};